<template>
    <div class="dropdown">
        <button style="border-color: rgba(0, 0, 0, 0.8); background-color: rgba(0, 0, 0, 0.8); color: white; width: 100%;"
            class="btn dropdown-toggle d-flex justify-content-between align-items-center" type="button"
            id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
            {{ selectedOption || "Din stad?" }}
            <i class="bi bi-chevron-down ms-2"></i>
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <!-- Search Bar -->
            <div class="px-3 py-2 search-container">
                <input type="text" class="form-control search-input" placeholder="Sök..." v-model="searchQuery" />
            </div>
            <!-- Filtered Options (Dynamic + Static) -->
            <li v-for="option in filteredOptions" :key="typeof option === 'string' ? option : option.key"
                class="dropdown-item option-item" @click="selectOption(option)">
                {{ typeof option === "string" ? option : option.value }}
            </li>
        </ul>
    </div>
</template>

<script>
import { toRaw } from "vue";
import localStorageService from "../localStorageService/localStorageService.js";
import { EventBus } from '../api/EventBusMixin';
import AxiosInstance from "../api/axios";
import KeyValueModel from "../aggrigates/generals/models/KeyValueModel.js";

export default {
    name: "DropdownList",
    props: {
        options: {
            type: Array,
            default: () => [], // Default to empty array
        },
    },
    data() {
        return {
            searchQuery: "",
            selectedOption: null,
            staticOptions: [],
        };
    },
    computed: {
        
        filteredOptions() {
            if(this.staticOptions.length == 0){
                return;
            }
            
            const allOptions = this.options.concat(toRaw(this.staticOptions)); // Combine options
            return allOptions.filter((option) => {
                const value = typeof option === "string" ? option : option.value;
                const match = value
                    .toLowerCase()
                    .includes(this.searchQuery.toLowerCase());
                return match;
            });
        },
    },
    async mounted() {
        await this.getCities();
        this.selectedOption = localStorageService.get("selected-city");
        this.$gtag.pageview({ page_path: 'Select-City' });
    },
    methods: {
        async getCities(){
            // const cachedEvents = localStorageService.get("ecentstaden-city");
            //     if (cachedEvents) {
            //         this.staticOptions = cachedEvents;
            //         return;
            //     }

                const response = await AxiosInstance.get("profilings/cities");
                if(!response.data)
                {
                    return;
                }
                this.staticOptions = toRaw(response.data).map(item => new KeyValueModel(item.id, item.name));
                this.staticOptions.unshift(new KeyValueModel("-1", "Ingen stad"));
                // localStorageService.set("ecentstaden-city", this.staticOptions, 4);
        },
        selectOption(option) {
            this.selectedOption =
                typeof option === "string" ? option : option.value;
            if(this.selectedOption == "Ingen stad"){
                localStorageService.remove("selected-city");
            }
            else{
                localStorageService.set("selected-city", this.selectedOption);
            }
            EventBus.emit('city-was-changed');
            this.$emit("select");
        },
    },
};
</script>

<style scoped>
.dropdown-menu {
    width: 100% !important;
    max-height: 400px;
    /* Limit the height for scroll */
    overflow-y: auto;
    /* Enable vertical scrolling */
    background-color: rgba(0, 0, 0, 1) !important;
    /* Consistent background color */
    color: white;
    /* Text color */
    border: 1px solid rgba(0, 0, 0, 0.8);
    /* Border consistent with theme */
    width: 200px;
    /* Fixed width for the dropdown */
    scrollbar-width: thin;
    /* Firefox: Thin scrollbar */
    scrollbar-color: rgba(0, 0, 0, 0.8) rgba(0, 0, 0, 0.8);
    /* Firefox: Customize scrollbar */
}

/* Webkit Browsers (Chrome, Edge, Safari) */
.dropdown-menu::-webkit-scrollbar {
    width: 8px;
    /* Width of the scrollbar */
}

.dropdown-menu::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.8);
    /* Scrollbar thumb color */
    border-radius: 4px;
    /* Rounded edges */
}

.dropdown-menu::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.8);
    /* Darker on hover */
}

.dropdown-item {
    color: white !important;
    /* Text color for items */
    transition: background-color 0.3s ease;
}

.dropdown-item:hover {
    cursor: pointer;
    background-color: #15243d !important;
    /* Darker shade for hover effect */
}

.form-control:focus{
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
}

.search-container {
    width: 100%;
    /* Ensure the search bar spans the dropdown width */
    background-color: rgba(0, 0, 0, 0.8);
    /* Match the dropdown menu background */
    border-bottom: 1px solid rgba(0, 0, 0, 0.8);
    /* Subtle separation */
}

.search-input {
    background-color: #141313;
    /* Input field background */
    color: white !important;
    /* Input text color */
    border: 1px solid rgba(0, 0, 0, 0.8);
    /* Input border color */
    width: 100%;
    /* Full width for input */
}

.search-input::placeholder {
    color: white;
    /* Placeholder text color */
}

.search-input:focus {
    border-color: rgba(0, 0, 0, 0.8);
    /* Highlight border when focused */
    box-shadow: 0 0 5px rgba(241, 196, 15, 0.5);
    /* Optional glow effect */
}
</style>